import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { GroupsOfGroupEffects } from './groups-of-group.effects';
import { groupsOfGroupReducer } from './groups-of-group.reducer';

export const provideGroupsOfGroupStore = () => [
  provideState('groupsOfGroups', groupsOfGroupReducer),
  provideEffects([GroupsOfGroupEffects]),
];
